
export default function PurePlusIcon(props) {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" {...props} xmlns="http://www.w3.org/2000/svg">
            <path fill={props?.fill || "#fff"} d="M11.3333 6.00033C11.3333 6.34007 11.0577 6.61571 10.7179 6.61571H6.61534V10.7183C6.61534 11.058 6.3397 11.3337 5.99996 11.3337C5.66022 11.3337 5.38457 11.058 5.38457 10.7183V6.61571H1.28201C0.942267 6.61571 0.666626 6.34007 0.666626 6.00033C0.666626 5.66058 0.942267 5.38494 1.28201 5.38494H5.38457V1.28238C5.38457 0.942633 5.66022 0.666992 5.99996 0.666992C6.3397 0.666992 6.61534 0.942633 6.61534 1.28238V5.38494H10.7179C11.0577 5.38494 11.3333 5.66058 11.3333 6.00033Z" />
        </svg>
    )
}
